import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
} from '../../../utils/redux';

export const consts = createReqConsts('schedule', 'patient-type');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'appointments',
  type: 'get',
  slug: [
    'services',
    {
      type: 'payload',
      selector: ['serviceId'],
    },
    'patient_types',
    {
      type: 'payload.query',
      queryParameter: 'available_at_provider_calendar',
      value: 'yes',
    },
  ],
});

export default createReqReducer(consts);



// WEBPACK FOOTER //
// ./src/redux/schedule/requests/patient-type-req.js